<template>
    <div v-if="item.type">
        <component v-bind="config" @update="$emit('update', $event)"/>
    </div>
    <div v-else>&nbsp;</div>
</template>

<script>
    import QueryLine from '@/components/query2/query-line';

    const textEditor = () => import(/* webpackChunkName: "query2" */'@/components/query2/components/editors/text-editor');
    const boolEditor = () => import(/* webpackChunkName: "query2" */'@/components/query2/components/editors/boolean-editor');
    const datetimeEditor = () => import(/* webpackChunkName: "query2" */'@/components/query2/components/editors/datetime-editor');
    const numericEditor = () => import(/* webpackChunkName: "query2" */'@/components/query2/components/editors/numeric-editor');
    const emptyEditor = () => import(/* webpackChunkName: "query2" */'@/components/query2/components/editors/empty-editor');

    export default {
        name: 'value-selector',
        props: {
            item: QueryLine,
            validate: Object,
        },
        computed: {
            config() {
                return {
                    is: this.getComponentForItem({
                        text: textEditor,
                        empty: emptyEditor,
                        bool: boolEditor,
                        datetime: datetimeEditor,
                        numeric: numericEditor,
                    }),
                    item: this.item,
                    validate: this.validate,
                };
            },
        },
        methods: {
            /**
             * Identity method that maps components to query line types.
             * @param text
             * @param empty
             * @param bool
             * @param datetime
             * @param numeric
             * @returns {*}
             */
            getComponentForItem({
                text, empty, bool, datetime, numeric,
            }) {
                switch (this.item.type) {
                    case QueryLine.Types.numeric:
                        return numeric;
                    case QueryLine.Types.datetime:
                        return datetime;
                    case QueryLine.Types.boolean:
                        return bool;
                    case QueryLine.Types.text:
                        return text;
                    default:
                        return empty;
                }
            },
        },
    };
</script>
